import React from "react";
import { useState, useEffect } from "react";
import { Carousel } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";

function Testimonials(props) {
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    const reviews = [
        {
            client: "Marla Gonzalez",
            subheader: "Amazing experience",
            review: "I had such an amazing experience with Peaches. My brow shaping and brow stain were everything I wanted and more! I got compliments all day long. Rachelle is so kind, sweet, and professional. 10/10 experience 😊",
        },
        {
            client: "Madeleine",
            subheader: "Space is so cute!",
            review: "The best waxing experience ever!!! Space is so cute and it was quick and painless! Love it!!",
        },
        {
            client: "Bonnie",
            subheader: "Brow Shaping + Stain",
            review: "Rachelle is the best! I always leave feeling better than when I walked in! Highly recommend 😊",
        },
        {
            client: "Heidi",
            subheader: "Highly recommend",
            review: "I always feel great after a visit at Peaches! Highly recommend!",
        },
        {
            client: "Ashley",
            subheader: "So welcoming",
            review: "Rachelle made my first bikini wax experience really comfortable! Her space is so welcoming",
        },
    ];

    let perPage = 3;
    if (windowSize.width < 900) {
        perPage = 1;
    }
    let groupedArray = [];
    for (let i = 0; i < reviews.length; i += perPage) {
        groupedArray.push(reviews.slice(i, i + perPage));
    }

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        // Add event listener
        window.addEventListener("resize", handleResize);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []); // Empty dependency array ensures this runs once on mount

    return (
        <section id="testimonials" className="flex justify-center pb-3">
            <div className="flex flex-col h-full w-full">
                <Carousel>
                    {groupedArray.map((slide, i) => {
                        return (
                            <Carousel.Item key={`carousel-${i}`}>
                                <div
                                    key={`container-${i}`}
                                    className="item-container flex justify-center gap-12 w-full pt-8 pb-12"
                                >
                                    {slide.map((rev) => {
                                        return (
                                            <div
                                                key={`card-${rev.client}`}
                                                className=""
                                            >
                                                <div className="card flex flex-col ">
                                                    <div className="stars flex justify-center w-full mb-3 text-peachOrange">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 24 24"
                                                            fill="currentColor"
                                                            className="size-6"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                                                                clipRule="evenodd"
                                                            />
                                                        </svg>
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 24 24"
                                                            fill="currentColor"
                                                            className="size-6"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                                                                clipRule="evenodd"
                                                            />
                                                        </svg>
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 24 24"
                                                            fill="currentColor"
                                                            className="size-6"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                                                                clipRule="evenodd"
                                                            />
                                                        </svg>
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 24 24"
                                                            fill="currentColor"
                                                            className="size-6"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                                                                clipRule="evenodd"
                                                            />
                                                        </svg>
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 24 24"
                                                            fill="currentColor"
                                                            className="size-6"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                                                                clipRule="evenodd"
                                                            />
                                                        </svg>
                                                    </div>
                                                    <div className="flex text-4xl mb-3 text-peachOrange text-center justify-center items-center h-20 font-fredoka font-semibold">
                                                        <span className="text-center">
                                                            {rev.subheader}
                                                        </span>
                                                    </div>
                                                    <div className="card-description text-xl mb-auto text-peachBlack text-center ">
                                                        {rev.review}
                                                    </div>

                                                    <div
                                                        key={`title-${rev.client}`}
                                                        className="card-title font-semibold text-peachBlack text-center"
                                                    >
                                                        {rev.client}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </Carousel.Item>
                        );
                    })}
                </Carousel>
                <div className="flex justify-center my-2">
                    <div className=" bg-peach font-semibold py-2 px-4 w-fit rounded-2xl">
                        <Link
                            className="text-white"
                            to="https://www.google.com/search?q=peaches+corpus+christi&sca_esv=baa52ac9cd6c629f&source=hp&ei=7OJ5Z6L7IK-7p84PhJu7qQU&iflsig=AL9hbdgAAAAAZ3nw_Hk0DSLTngfUS6AMmKBXpidvQ2MI&gs_ssp=eJzj4tVP1zc0LCsuia-wTDEzYLRSNaiwMDOzME1LTkw0S0tNNjdPszKoMEk2tDQxMU9LM0u0NEgxN_ISK0hNTM5ILVZIzi8qKAVSGUWZxSWZAI2YGHg&oq=peaches+corpus+chri&gs_lp=Egdnd3Mtd2l6IhNwZWFjaGVzIGNvcnB1cyBjaHJpKgIIADIOEC4YgAQYxwEYjgUYrwEyBhAAGBYYHjIGEAAYFhgeMgsQABiABBiGAxiKBTILEAAYgAQYhgMYigUyBRAAGO8FMgUQABjvBTIIEAAYogQYiQUyBRAAGO8FMggQABiiBBiJBUi8N1AAWPwpcAd4AJABAJgBXqAB3g2qAQIyNLgBAcgBAPgBAZgCH6ACuA7CAg4QLhiABBixAxjRAxjHAcICCxAAGIAEGLEDGIMBwgILEC4YgAQYsQMYgwHCAgUQABiABMICCxAuGIAEGNEDGMcBwgIREC4YgAQYsQMY0QMYgwEYxwHCAggQLhiABBixA8ICCBAAGIAEGLEDwgILEC4YgAQYxwEYrwHCAgsQLhiABBixAxjUAsICCBAuGIAEGOUEwgILEAAYgAQYsQMYigXCAgUQLhiABMICBxAAGIAEGArCAggQABgWGAoYHsICBRAhGKABwgIFECEYqwLCAgUQIRifBcICDhAuGNEDGBYYxwEYChgewgIIEAAYgAQYogSYAwCSBwIzMaAH84oC&sclient=gws-wiz#lrd=0x86685fcaa6fec77f:0x4c19447ff6a90d72,1,,,,"
                        >
                            Send a love note!
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Testimonials;
